"use client";

import { memo, ReactNode } from "react";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";

const CompleteConfirmModal = memo(
  ({
    isOpen,
    title,
    onConfirm,
    onClose,
    positiveButtonLabel = "完了にする",
  }: {
    isOpen: boolean;
    title: ReactNode;
    onConfirm: () => Promise<void>;
    onClose: () => void;
    positiveButtonLabel?: string;
  }) => {
    const onClick = async () => {
      await onConfirm();
    };

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <div className="mx-14 mb-5 mt-10 flex flex-col items-center">
          <p className="mb-[81px] mt-8 text-center text-[19.2px]">{title}</p>
          <div className="flex gap-4">
            <Button text="キャンセル" onClick={onClose} style={ButtonStyle.OUTLINE} width="w-[160px]" />
            <Button text={positiveButtonLabel} onClick={onClick} style={ButtonStyle.PRIMARY} width="w-[160px]" />
          </div>
        </div>
      </Modal>
    );
  }
);

CompleteConfirmModal.displayName = "CompleteConfirmModal";

export default CompleteConfirmModal;
